const PanelIcon = ({ fillColor, strokeColor, strokeWidth, innerWidth, width }) => {
  return (
    <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.96 18.43" width={width}>
      <path
        d="M17.68,1H5.28c-1.47,0-2.72,1.06-2.96,2.51l-1.28,7.69c-.3,1.83,1.11,3.49,2.96,3.49h14.96c1.85,0,3.26-1.66,2.96-3.49l-1.28-7.69c-.24-1.45-1.49-2.51-2.96-2.51Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M8.28,1.21l-1,13.61"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={innerWidth}
      />
      <path
        d="M14.78,1.21l.81,14.04"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={innerWidth}
      />
      <line
        x1="21.06"
        y1="5.21"
        x2="1.89"
        y2="5.21"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={innerWidth}
      />
      <line
        x1="21.06"
        y1="10.21"
        x2="1.89"
        y2="10.21"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={innerWidth}
      />
      <path
        d="M21.94,17.43H1.02"
        fill={fillColor}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default PanelIcon;
